export const RETAIN_SNAPSHOT_MS = 5 * 60000;
const timestamp = value => typeof value === "number" ? value : Date.parse(value);
export function monitorNeedsRetry(snapshot) {
  const state = snapshot?._errorMonitor;
  return !snapshot || !!state && (state.status === "unavailable" || ["not_loaded", "loading", "unavailable"].includes(state.readState));
}
export function mergeMonitorSnapshot(previous, next, now = Date.now()) {
  const state = next?._errorMonitor;
  const old = previous?._errorMonitor;
  const at = timestamp(previous?._meta?.computedAt ?? previous?.computedAt);
  const sameSource = !old?.sourceFingerprint || !state?.sourceFingerprint || old.sourceFingerprint === state.sourceFingerprint;
  const readMissing = state && !["available", "partial"].includes(state.readState)
    && state.cacheComplete !== true && (state.status !== "active" || ["not_loaded", "loading", "unavailable"].includes(state.readState));
  if (previous?.iflows?.length && !next?.iflows?.length && readMissing && sameSource
    && Number.isFinite(at) && now >= at && now - at <= RETAIN_SNAPSHOT_MS) {
    return { ...previous, _errorMonitor: { ...state, observedAt: old?.observedAt, checkedAt: old?.checkedAt,
      loadedRecords: old?.loadedRecords, historyComplete: false, retainedSnapshot: true },
      _meta: { ...previous._meta, lastError: next?._meta?.lastError } };
  }
  return next;
}
export function monitorReason(monitor, t) {
  const reason = monitor?.reason;
  return typeof reason === "string" && reason !== "other" && /^[a-z][a-z0-9_]{0,95}$/i.test(reason)
    ? t(`errorMonitorCosts:notice.reason.${reason}`, { defaultValue: t(`errorMonitorCosts:reason.${reason}`, { defaultValue: t("errorMonitorCosts:reason.unknown") }) })
    : t("errorMonitorCosts:reason.unknown");
}

export function mergeMonitorStatistics(previous, next, now = Date.now()) {
  const state = next?._errorMonitor;
  const at = timestamp(previous?._errorMonitor?.observedAt ?? previous?._errorMonitor?.checkedAt);
  if (state?.status === "unavailable" && !["available", "partial"].includes(state.readState)
    && state.cacheComplete !== true && next.total == null && next.failed == null
    && previous && Number.isFinite(at) && now >= at && now - at <= RETAIN_SNAPSHOT_MS
    && (!state.sourceFingerprint || !previous._errorMonitor?.sourceFingerprint || state.sourceFingerprint === previous._errorMonitor.sourceFingerprint)) {
    return { ...previous, _errorMonitor: { ...state, observedAt: previous._errorMonitor.observedAt,
      checkedAt: previous._errorMonitor.checkedAt, retainedSnapshot: true, historyComplete: false }, ageMs: now - at };
  }
  return next;
}
